import { combineReducers } from "redux";
import {
  MENTOR_LIST,
  VIEW_PREDEFINED_OPTIONS,
  VIEW_MENTORLIST_COUNTER_OPTIONS,
} from "../../../../../common/constants/actionConstants";

const getMentorList = (state = [], action) => {
  switch (action.type) {
    case MENTOR_LIST:
      return { ...action.payload };
    default:
      return state;
  }
};

const getPredefineOptionsList = (state = [], action) => {
  switch (action.type) {
    case VIEW_PREDEFINED_OPTIONS:
      return { ...action.payload };
    default:
      return state;
  }
};
const getMentorlistCountersList = (state = [], action) => {
  switch (action.type) {
    case VIEW_MENTORLIST_COUNTER_OPTIONS:
      return { ...action.payload };
    default:
      return state;
  }
};

const AdminMentorListReducer = combineReducers({
  getMentorList,
  getPredefineOptionsList,
  getMentorlistCountersList,
});

export default AdminMentorListReducer;
